import ProjectLinks from '../../project.links';

export const notAllowedForAdminsPages: string[] = [
  ProjectLinks.LINK_BLOCKED_USERS,
  ProjectLinks.LINK_CHAT,
  ProjectLinks.LINK_COMMUNITY_ALL,
  ProjectLinks.LINK_COMMUNITY_CREATE,
  ProjectLinks.LINK_COMMUNITY_INVITE,
  ProjectLinks.LINK_CONNECTIONS,
  ProjectLinks.LINK_CONNECTIONS_LIST,
  ProjectLinks.LINK_CONNECTIONS_GROUP_MESSAGE,
  ProjectLinks.LINK_FILES,
  ProjectLinks.LINK_FILES_MANAGER,
  ProjectLinks.LINK_FILES_DETAILS,
  ProjectLinks.LINK_POSTS,
  ProjectLinks.LINK_POSTS_ALL,
  ProjectLinks.LINK_POSTS_CREATE,
  ProjectLinks.LINK_PROJECTS_ALL,
  ProjectLinks.LINK_PROJECTS_CREATE,
  ProjectLinks.LINK_PROJECTS_INVITE,
  ProjectLinks.LINK_PREFERENCES,
  ProjectLinks.LINK_COMMUNITY_MANAGE,
  ProjectLinks.LINK_PROJECTS_MANAGE,
];

export const onlyAllowedForAdminsPages: string[] = [ProjectLinks.LINK_DEACTIVATED_USERS, ProjectLinks.LINK_CATEGORIES];

export const allowedForAdminsOnlyPages: string[] = [ProjectLinks.LINK_ADMINS];

export const exceptionPages: string[] = [
  'projects/view/:id',
  'posts/view/:id',
  'community/:id',
  'projects/manage/:id',
  'community/manage/:id',
];

export const forbiddenSocialSubpages: string[] = ['', 'all', 'create'];
